import { cn } from "@theprelude/core";
import { LoaderIcon } from "../icons/loader-icon";

export const Loading: React.FC<{ className?: string }> = ({ className }) => {
  return <LoaderIcon className={cn("mx-auto my-0 animate-spin", className)} />;
};
